import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { LanguageService } from 'app/services/language.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { TenantSelectorService } from 'app/services/tenant-selector.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class LanguageSelectorComponent implements OnInit {
    languages: any;
    selectedLanguage: any;
    loading = false
    @Input() orientation: 'up' | 'down' = 'down';
    private refreshInterval: number;
    timerRefresh: number;
    constructor(
        private _translateService: TranslateService,
        private _languageService: LanguageService,
        private _fuseSplashScreenService:FuseSplashScreenService
    ) {
        const tenantId = location.pathname.split('/')[2]
        const tenantIdStorage = MVLocalStorageService.getItem('tenantId')
        if(!tenantIdStorage && tenantId){
            MVLocalStorageService.setItem('tenantId',tenantId)
        }else{
            if(tenantIdStorage != tenantId){
                if(MVLocalStorageService.getItem('languages')){
                    const languages: any[] = JSON.parse(MVLocalStorageService.getItem('languages'))
                    languages.forEach(element => {
                      if(MVLocalStorageService.getItem(element.id + '.json')){
                        MVLocalStorageService.removeItem(element.id + '.json')
                      }
                  });
                }
                MVLocalStorageService.removeItem('languages')
                MVLocalStorageService.removeItem('selected_lang')
                if(tenantId){
                    MVLocalStorageService.setItem('tenantId',tenantId)
                }else{
                    MVLocalStorageService.removeItem('tenantId')
                }
                
            }
        }
        this.timerRefresh = 60000;
        this.getLanguages()
    }

    getLanguages(){
        if (MVLocalStorageService.getItem('languages')){
            this.languages = JSON.parse(MVLocalStorageService.getItem('languages'));
            this.getSelectedLanguage()
        }else{
            this._languageService.getList().subscribe(res => {
                MVLocalStorageService.setItem("languages", JSON.stringify(res));
                this.languages= res;
                this.getSelectedLanguage()
            })
        }
    }

    setLanguage(lang): void {
        this._fuseSplashScreenService.show()
        this.getFullLabels(lang.id);
    }

    getSelectedLanguage(){
        if (MVLocalStorageService.getItem('selected_lang')) {
            this.selectedLanguage = JSON.parse(MVLocalStorageService.getItem('selected_lang'));
            this.checkSelectedLanguageInLanguages(this.languages,  this.selectedLanguage);
        } else {
            const selectedLangId = this.languages[0].id;
            this.getFullLabels(selectedLangId);
        }
    }

    checkSelectedLanguageInLanguages(languages, selectedLang){
        if (!languages.some(lang => lang.id === selectedLang.id)){
            var selectedLangId = languages[0].id;
            this.getFullLabels(selectedLangId);
        }else{
            this.checkLanguageNeedToUpdate(this.selectedLanguage.id, this.selectedLanguage.lastModifiedDateLabel);
            this.setTranslation(this.selectedLanguage.id)
        }
    }

    getFullLabels(langId) {
        this._languageService.getFullLanguage(langId).subscribe(res => {
            this.selectedLanguage = res
            MVLocalStorageService.setItem('selected_lang', JSON.stringify(res))
            const json = this.createLabels(res.labels)
            MVLocalStorageService.setItem(langId + '.json', JSON.stringify(json));
            this.setTranslation(langId);
        })
    }

    checkLanguageNeedToUpdate(langId,lastModifiedDateLabel) {
        this._languageService.getNeedToUpdateLanguage(langId,lastModifiedDateLabel).subscribe(res => {
            if(res){
                this.getFullLabels(langId);
            }
        })
    }
    
    createLabels(labels: any[]) {
        const result = {};
        labels.forEach(label => {
            result[label.labelKey] = label.translation;
        });
        return result;
    }

    setTranslation(langId) {
        this._translateService.getTranslation(langId).subscribe(translations => {
            this._translateService.use(langId);
            this._translateService.setTranslation(langId, translations)
            this.loading = true
            this._fuseSplashScreenService.hide();
        });
    }

    changeTenant() {
        //SI EL KEY DEL STORAGE !== A URL
        MVLocalStorageService.removeItem('languages')
        MVLocalStorageService.removeItem('selected_lang')
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.refreshInterval = window.setInterval(() => {
           this.getSelectedLanguage()
        }, this.timerRefresh);
    }
}
